module.exports = __webpack_public_path__ + "a80254c2714e2ec6cccd65b4c5660d44.pdf";